import { render } from "./Colors.vue?vue&type=template&id=8741dec6"
import script from "./Colors.vue?vue&type=script&lang=ts"
export * from "./Colors.vue?vue&type=script&lang=ts"
script.render = render

export default script